import { Translation } from 'primeng/api';

export const translation: Translation = {
  startsWith: $localize`Beginnt mit`,
  contains: $localize`Enthält`,
  notContains: $localize`Enthält nicht`,
  endsWith: $localize`Endet mit`,
  equals: $localize`Entspricht`,
  notEquals: $localize`Entspricht nicht`,
  noFilter: $localize`Kein Filter`,
  lt: $localize`Kleiner als`,
  lte: $localize`Kleiner oder gleich als`,
  gt: $localize`Grösser als`,
  gte: $localize`Grösser oder gleich als`,
  is: $localize`Ist`,
  isNot: $localize`Ist nicht`,
  before: $localize`Bevor`,
  after: $localize`Nach`,
  dateIs: $localize`Datum ist`,
  dateIsNot: $localize`Datum ist nicht`,
  dateBefore: $localize`Datum ist vor`,
  dateAfter: $localize`Datum ist nach`,
  clear: $localize`Löschen`,
  apply: $localize`Anwenden`,
  matchAll: $localize`Alle`,
  matchAny: $localize`Einige`,
  addRule: $localize`Regel hinzufügen`,
  removeRule: $localize`Regel entfernen`,
  accept: $localize`Ja`,
  reject: $localize`Nein`,
  choose: $localize`Wählen`,
  upload: $localize`Hochladen`,
  cancel: $localize`Abbrechen`,
  dayNames: [
    $localize`Sonntag`,
    $localize`Montag`,
    $localize`Dienstag`,
    $localize`Mittwoch`,
    $localize`Donnerstag`,
    $localize`Freitag`,
    $localize`Sonntag`,
  ],
  dayNamesShort: [
    $localize`Son`,
    $localize`Mon`,
    $localize`Die`,
    $localize`Mit`,
    $localize`Don`,
    $localize`Fre`,
    $localize`Sam `,
  ],
  dayNamesMin: [
    $localize`So`,
    $localize`Mo`,
    $localize`Di`,
    $localize`Mi`,
    $localize`Do`,
    $localize`Fr`,
    $localize`Sa`,
  ],
  monthNames: [
    $localize`Januar`,
    $localize`Februar`,
    $localize`März`,
    $localize`April`,
    $localize`Mai`,
    $localize`Juni`,
    $localize`Juli`,
    $localize`August`,
    $localize`September`,
    $localize`Oktober`,
    $localize`November`,
    $localize`Dezember`,
  ],
  monthNamesShort: [
    $localize`Jan`,
    $localize`Feb`,
    $localize`Mrz`,
    $localize`Apr`,
    $localize`Mai`,
    $localize`Jun`,
    $localize`Jul`,
    $localize`Aug`,
    $localize`Sep`,
    $localize`Okt`,
    $localize`Nov`,
    $localize`Dez`,
  ],
  dateFormat: 'dd.mm.yy',
  firstDayOfWeek: 1,
  today: $localize`Heute`,
  weekHeader: $localize`Wk`,
  weak: $localize`Schwach`,
  medium: $localize`Mittel`,
  strong: $localize`Stark`,
  passwordPrompt: $localize`Passwort eingeben`,
  emptyMessage: $localize`Keine Resultate gefunden`,
  emptyFilterMessage: $localize`Keine Resultate gefunden`,
};
